/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { TeamNoteDto } from "./TeamNoteDto";
import {
  TeamNoteDtoFromJSON,
  TeamNoteDtoFromJSONTyped,
  TeamNoteDtoToJSON,
  TeamNoteDtoToJSONTyped,
} from "./TeamNoteDto";
import type { TimelineEntry } from "./TimelineEntry";
import {
  TimelineEntryFromJSON,
  TimelineEntryFromJSONTyped,
  TimelineEntryToJSON,
  TimelineEntryToJSONTyped,
} from "./TimelineEntry";
import type { MemberTeam } from "./MemberTeam";
import {
  MemberTeamFromJSON,
  MemberTeamFromJSONTyped,
  MemberTeamToJSON,
  MemberTeamToJSONTyped,
} from "./MemberTeam";
import type { TimeOffDto } from "./TimeOffDto";
import {
  TimeOffDtoFromJSON,
  TimeOffDtoFromJSONTyped,
  TimeOffDtoToJSON,
  TimeOffDtoToJSONTyped,
} from "./TimeOffDto";
import type { EngagementType } from "./EngagementType";
import {
  EngagementTypeFromJSON,
  EngagementTypeFromJSONTyped,
  EngagementTypeToJSON,
  EngagementTypeToJSONTyped,
} from "./EngagementType";

/**
 *
 * @export
 * @interface TeamMemberDetail
 */
export interface TeamMemberDetail {
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  teamMemberId: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  personalEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  personalPhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  mailingAddress?: string | null;
  /**
   *
   * @type {number}
   * @memberof TeamMemberDetail
   */
  birthdayMonth?: number | null;
  /**
   *
   * @type {number}
   * @memberof TeamMemberDetail
   */
  birthdayDay?: number | null;
  /**
   *
   * @type {LocalDate}
   * @memberof TeamMemberDetail
   */
  joinDate?: LocalDate | null;
  /**
   *
   * @type {Array<string>}
   * @memberof TeamMemberDetail
   */
  permissions: Array<string>;
  /**
   *
   * @type {Array<TimeOffDto>}
   * @memberof TeamMemberDetail
   */
  timeOff: Array<TimeOffDto>;
  /**
   *
   * @type {Array<TeamNoteDto>}
   * @memberof TeamMemberDetail
   */
  notes: Array<TeamNoteDto>;
  /**
   *
   * @type {Array<TimelineEntry>}
   * @memberof TeamMemberDetail
   */
  timeline: Array<TimelineEntry>;
  /**
   *
   * @type {Array<MemberTeam>}
   * @memberof TeamMemberDetail
   */
  teams: Array<MemberTeam>;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  hourlyRate?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  legalFullName?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  jobTitle?: string | null;
  /**
   *
   * @type {EngagementType}
   * @memberof TeamMemberDetail
   */
  engagementType?: EngagementType | null;
  /**
   *
   * @type {CurrencyCode}
   * @memberof TeamMemberDetail
   */
  currency?: CurrencyCode | null;
  /**
   *
   * @type {LocalDate}
   * @memberof TeamMemberDetail
   */
  endDate?: LocalDate | null;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  regularWeeklyExtraHours?: string | null;
  /**
   *
   * @type {string}
   * @memberof TeamMemberDetail
   */
  keyDatesPath: string;
  /**
   *
   * @type {boolean}
   * @memberof TeamMemberDetail
   */
  engagementLetterReady: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof TeamMemberDetail
   */
  githubIds: Array<string>;
}

/**
 * Check if a given object implements the TeamMemberDetail interface.
 */
export function instanceOfTeamMemberDetail(
  value: object,
): value is TeamMemberDetail {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("firstName" in value) || value["firstName"] === undefined) return false;
  if (!("lastName" in value) || value["lastName"] === undefined) return false;
  if (!("permissions" in value) || value["permissions"] === undefined)
    return false;
  if (!("timeOff" in value) || value["timeOff"] === undefined) return false;
  if (!("notes" in value) || value["notes"] === undefined) return false;
  if (!("timeline" in value) || value["timeline"] === undefined) return false;
  if (!("teams" in value) || value["teams"] === undefined) return false;
  if (!("keyDatesPath" in value) || value["keyDatesPath"] === undefined)
    return false;
  if (
    !("engagementLetterReady" in value) ||
    value["engagementLetterReady"] === undefined
  )
    return false;
  if (!("githubIds" in value) || value["githubIds"] === undefined) return false;
  return true;
}

export function TeamMemberDetailFromJSON(json: any): TeamMemberDetail {
  return TeamMemberDetailFromJSONTyped(json, false);
}

export function TeamMemberDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TeamMemberDetail {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    email: json["email"],
    firstName: json["firstName"],
    lastName: json["lastName"],
    personalEmail:
      json["personalEmail"] == null ? undefined : json["personalEmail"],
    personalPhone:
      json["personalPhone"] == null ? undefined : json["personalPhone"],
    mailingAddress:
      json["mailingAddress"] == null ? undefined : json["mailingAddress"],
    birthdayMonth:
      json["birthdayMonth"] == null ? undefined : json["birthdayMonth"],
    birthdayDay: json["birthdayDay"] == null ? undefined : json["birthdayDay"],
    joinDate: json["joinDate"] == null ? undefined : json["joinDate"],
    permissions: json["permissions"],
    timeOff: (json["timeOff"] as Array<any>).map(TimeOffDtoFromJSON),
    notes: (json["notes"] as Array<any>).map(TeamNoteDtoFromJSON),
    timeline: (json["timeline"] as Array<any>).map(TimelineEntryFromJSON),
    teams: (json["teams"] as Array<any>).map(MemberTeamFromJSON),
    hourlyRate: json["hourlyRate"] == null ? undefined : json["hourlyRate"],
    legalFullName:
      json["legalFullName"] == null ? undefined : json["legalFullName"],
    jobTitle: json["jobTitle"] == null ? undefined : json["jobTitle"],
    engagementType:
      json["engagementType"] == null
        ? undefined
        : EngagementTypeFromJSON(json["engagementType"]),
    currency:
      json["currency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["currency"]),
    endDate: json["endDate"] == null ? undefined : json["endDate"],
    regularWeeklyExtraHours:
      json["regularWeeklyExtraHours"] == null
        ? undefined
        : json["regularWeeklyExtraHours"],
    keyDatesPath: json["keyDatesPath"],
    engagementLetterReady: json["engagementLetterReady"],
    githubIds: json["githubIds"],
  };
}

export function TeamMemberDetailToJSON(json: any): TeamMemberDetail {
  return TeamMemberDetailToJSONTyped(json, false);
}

export function TeamMemberDetailToJSONTyped(
  value?: TeamMemberDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    email: value["email"],
    firstName: value["firstName"],
    lastName: value["lastName"],
    personalEmail: value["personalEmail"],
    personalPhone: value["personalPhone"],
    mailingAddress: value["mailingAddress"],
    birthdayMonth: value["birthdayMonth"],
    birthdayDay: value["birthdayDay"],
    joinDate: value["joinDate"],
    permissions: value["permissions"],
    timeOff: (value["timeOff"] as Array<any>).map(TimeOffDtoToJSON),
    notes: (value["notes"] as Array<any>).map(TeamNoteDtoToJSON),
    timeline: (value["timeline"] as Array<any>).map(TimelineEntryToJSON),
    teams: (value["teams"] as Array<any>).map(MemberTeamToJSON),
    hourlyRate: value["hourlyRate"],
    legalFullName: value["legalFullName"],
    jobTitle: value["jobTitle"],
    engagementType: EngagementTypeToJSON(value["engagementType"]),
    currency: CurrencyCodeToJSON(value["currency"]),
    endDate: value["endDate"],
    regularWeeklyExtraHours: value["regularWeeklyExtraHours"],
    keyDatesPath: value["keyDatesPath"],
    engagementLetterReady: value["engagementLetterReady"],
    githubIds: value["githubIds"],
  };
}
